<script lang="ts">
  import CurrentUserStore from "@shared/svelte/Stores/CurrentUserStore";
  import { bottleTopsEnglish } from "@shared/filters/bottle_tops_english.js";
  import AddToListButton from "./AddToListButton.svelte";
  import { sizeAndUnitsDisplay } from "@shared/services/product";
  import type { Product, ProductLine } from "@shared/types/ProductLine";
  import type { Distributor } from "@shared/types/Distributor";

  export let product: Product;
  export let productLine: ProductLine;
  export let customPricingMode: boolean;
  export let productIsRequestable: boolean;

  const capFirstLetter = function (string) {
    if (string == "other") {
      return "";
    }
    return string.charAt(0).toUpperCase() + string.slice(1);
  };

  const approvedProduct = product?.limited_ordering_product?.approval_status;

  let showAddToListButton;

  if ($CurrentUserStore.limited_ordering) {
    showAddToListButton =
      $CurrentUserStore.group_director && !approvedProduct && !customPricingMode;
  } else if (!customPricingMode) {
    showAddToListButton = true;
  }
</script>

<div class="grid-col c12-12">
  {#if approvedProduct}
    <div class="fizz-styles">
      <span class="fizz-stack-4 fizz-badge">Approved Product</span>
    </div>
  {/if}
  <div class="media fizz-styles">
    <div class="media-fluid media default-subheader--bold" class:opacity-20={productIsRequestable}>
      <div class="fizz-inline-4">
        {sizeAndUnitsDisplay(product)}
        {#if product.container_type == "bottle" && product.material}
          <span class="capitalize">{product.material} </span>
        {/if}
        {#if product.container_type == "bottle"}
          <span class="capitalize">{bottleTopsEnglish(product.bottle_tops)}</span>
        {/if}
        {capFirstLetter(product.container_type)}
      </div>
    </div>
    {#if showAddToListButton}
      <span class="media-fixed align-right">
        <AddToListButton {product} {productLine} />
      </span>
    {/if}
  </div>
</div>
